const comparator = (a, b) => (a || '').toString().localeCompare((b || '').toString(), 'en', { numeric: true });

export default <T>(arr: T[], iter: (m: T) => string) => arr.sort((a, b) => comparator(iter(a), iter(b)));